import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
selector: 'app-period-selector',
templateUrl: './period-selector.component.html',
styleUrl: './period-selector.component.scss'
})
export class PeriodSelectorComponent {

  @Output() rangeChange = new EventEmitter<any>();
  dateRange: FormControl = new FormControl();
  activeFilter: string = 'All';
  showCalendar = false;
  showDropdown = false;
  onOptionClick(filterType: string) {
    this.activeFilter = filterType;
    const today = new Date();
    let startDate: Date;
    let endDate: Date = new Date();

    switch (filterType) {
      case 'All':
        this.dateRange.setValue(null);
        this.rangeChange.emit(null);
        return;

      case 'This Month':
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        break;

      case 'Last 30 days':
        startDate = new Date();
        startDate.setDate(today.getDate() - 30);
        break;

      case 'Year To Date':
        startDate = new Date(today.getFullYear(), 0, 1);
        break;

      case 'This Final Year':
        startDate = getFiscalYearStart(today);
        break;

      case 'Last Final Year':
        const lastFYEnd = new Date(getFiscalYearStart(today).getTime() - 1);
        startDate = getFiscalYearStart(lastFYEnd);
        endDate = lastFYEnd;
        break;

      default:
        return;
    }

    this.dateRange.setValue([startDate, endDate]);
    this.rangeChange.emit([startDate, endDate]);
  }

  onDateRangeChange() {
    this.rangeChange.emit(this.dateRange.value);
  }
}
function getFiscalYearStart(date: Date): Date {
  const year = date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1;
  return new Date(year, 3, 1);
}





